export type LOADER_TYPES = 'CIRCLE' | 'SKELETON-CARD' | 'SKELETON-TABLE' | 'SKELETON-PLAIN' | 'NONE';

export const DEFAULT_LOADER = 'CIRCLE';

export const DEFAULT_LOADER_FOR_DYNAMIC_FORM = 'SKELETON-PLAIN';
